import includes from 'lodash/includes';

export const isStreetView = (photoUrl) => {
  return photoUrl && photoUrl.includes('&maptype=streetview');
};
export const isAerialPhoto = (photoUrl) => {
  return photoUrl && photoUrl.includes('&maptype=satellite');
};
export const updateCounts = (counts, image, imageList) => {
  if (isAerialPhoto(image)) {
    counts.aerial++;
  } else if (isStreetView(image)) {
    counts.streetView++;
  } else if (includes(imageList, image)) {
    counts.upload++;
  } else {
    counts.existing++;
  }
};